"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tools = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var react_redux_1 = require("react-redux");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var DiaryentriesActions = require("@caddigital/sok-reducers/lib/actions/diaryentries/list");
var DiaryentriesReducer = require("@caddigital/sok-reducers/lib/reducers/diaryentries/list");
var sok_ui_1 = require("@caddigital/sok-ui");
var Types = require("types");
var search_1 = require("utils/search");
var mapStateToProps = function (state, ownProps) {
    return {
        showBookmarked: state.diaryentries.list.filterOptions.bookmarked === 'true'
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    toggleShowBookmarks: function (status, currentWorksiteDiary) { return dispatch(DiaryentriesActions.setColumnFilter('bookmarked', status)); },
    clearFilters: function (data, currentWorksiteDiary) {
        return dispatch(DiaryentriesActions.setInitData(data, currentWorksiteDiary ? currentWorksiteDiary.diary_uuid : undefined));
    }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('DiaryentriesTools'), (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), recompose_1.pure);
exports.Tools = enhance(function (props) { return (React.createElement("div", { className: 'tools' },
    React.createElement(sok_ui_1.Button, { onClick: function () {
            var data = __assign(__assign({}, DiaryentriesReducer.defaultOrderByOptions), { limit: DiaryentriesReducer.defaultLimit.toString(), offset: DiaryentriesReducer.defaultOffset.toString() });
            var url = props.pathname + (0, search_1.getQueryParams)(data);
            props.updateUrl(url);
            props.clearFilters(data, props.currentWorksiteDiary);
        }, color: 'blue', text: (0, translation_1.getLocalization)('diaryEntriesView/tools/clearFilters') }))); });
